<template>
  <div class="ai-menu-setting">
    <div class="ai-menu-setting__card">
      <div class="ai-menu-setting__header">
        <span class="ai-menu-setting__prefix">🖐️ 轻松</span>
        <span class="ai-menu-setting__suffix">5 步让 AI 更好用</span>
      </div>

      <div class="ai-menu-setting__list">
        <div
          v-for="item in settingList"
          :key="item.title"
          class="ai-menu-setting__item"
          @click="handleItemClick(item)"
        >
          <div class="ai-menu-setting__info" :class="{ 'is-muted': item.isComplete === 1 }">
            <div class="ai-menu-setting__title">{{ item.title }}</div>
            <div class="ai-menu-setting__desc">{{ item.desc }}</div>
          </div>
          <i
            class="t-iconfont"
            :class="item.isComplete === 1 ? 'icon-checkbox-circle-fill' : 'icon-arrow-right-s-line'"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/store/useAppStore'
import { getInitSetupList } from './components/init-setup'

defineOptions({
  name: 'AiMenuSetting'
})

const appStore = useAppStore()

const handleItemClick = (item) => {
  if (item.isComplete === 0) {
    window.__openAiInitSetupDialog?.(item.alias)
  }
}

const settingList = computed(() => getInitSetupList(appStore.aiInitConfigDetails))
</script>

<style lang="scss" scoped>
.ai-menu-setting {
  padding: 12px 16px 16px;
}

.ai-menu-setting__card {
  padding: 12px 10px;
  border: 1px solid transparent;
  border-radius: 16px;
  box-sizing: border-box;
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    linear-gradient(332deg, #1574ff 3%, #5952ff 52%, #a969fe 96%) border-box;
}

.ai-menu-setting__header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.ai-menu-setting__prefix {
  color: #323233;
}

.ai-menu-setting__suffix {
  background: linear-gradient(276deg, #090120 1%, #4f16c1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.ai-menu-setting__item {
  display: flex;
  align-items: center;
  min-height: 64px;
  padding: 12px;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  box-sizing: border-box;
  .icon-arrow-right-s-line {
    cursor: pointer;
  }
}

.ai-menu-setting__item:not(:last-child) {
  margin-bottom: 4px;
}

.ai-menu-setting__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  text-align: center;
}

.ai-menu-setting__info.is-muted {
  opacity: 0.5;
}

.ai-menu-setting__title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #323233;
}

.ai-menu-setting__desc {
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #969799;
}

.ai-menu-setting__item .t-iconfont {
  flex: 0 0 18px;
  margin-left: 8px;
  font-size: 18px;
}

.icon-checkbox-circle-fill {
  color: #00c241;
}

.icon-arrow-right-s-line {
  color: #969799;
}
</style>
